import { CommonModule } from '@angular/common';
import { Component, computed, input, ChangeDetectionStrategy } from '@angular/core';
import { AbstractControl, ReactiveFormsModule, UntypedFormArray, UntypedFormGroup } from '@angular/forms';

import { v4 as uuid } from 'uuid';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles';

import { UiTranslateModule } from '@fcom/ui-translate/ui-translate.module';

import { IconsModule } from '../../icons/icons.module';
import { CheckBoxTheme } from '../enums';

@Component({
  selector: 'fcom-checkbox-input',
  imports: [CommonModule, ReactiveFormsModule, UiTranslateModule, IconsModule],
  templateUrl: './checkbox-input.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './checkbox-input.component.scss',
})
export class CheckboxInputComponent {
  readonly checkboxId: string = uuid();
  readonly CheckBoxTheme = CheckBoxTheme;
  readonly SvgLibraryIcon = SvgLibraryIcon;

  center = input<boolean>(false);
  checkboxValue = input<string | boolean>(false);
  controlName = input.required<string>();
  ctrlField = computed<AbstractControl | null>(() => this.parentForm()?.get(this.controlName()) ?? null);
  iconSize = input<string>('icon-medium');
  isRequired = computed<boolean>((): boolean => this.ctrlField()?.errors?.required ?? false);
  parentForm = input.required<UntypedFormGroup | UntypedFormArray>();
  showCheckboxIcon = input<boolean>(true);
  showRequiredError = input<boolean>(true);
  theme = input<CheckBoxTheme>(CheckBoxTheme.SQUARE);
  translationPrefix = input<string | undefined>();
  useLabelText = input<boolean>(false);
}
